"use client";
import {useEffect, useState} from "react";

import {useDevice} from "@/shared/utils/device/device-context";

interface Props {
    maxWidth: number;
}

// Common breakpoints
export const MOBILE_MAX = 767;
export const TABLET_MAX = 991;
export const TABLET_LANDSCAPE_MAX = 1024;

export function useMatchMedia({maxWidth}: Props): boolean {
    const device = useDevice();
    // SSR: estimate based on device type from user-agent
    const getInitialValue = (): boolean => {
        if (maxWidth <= MOBILE_MAX) return device.isMobile;
        if (maxWidth <= TABLET_MAX) return device.isMobile || device.isTablet;
        if (maxWidth <= TABLET_LANDSCAPE_MAX) return device.isMobile || device.isTablet;
        return true;
    };

    const [isViewport, setIsViewport] = useState(getInitialValue);

    useEffect(() => {
        const mediaQuery = window.matchMedia(`(max-width: ${maxWidth}px)`);
        const updateViewport = (): void => setIsViewport(mediaQuery.matches);
        updateViewport();
        mediaQuery.addEventListener("change", updateViewport);
        return () => mediaQuery.removeEventListener("change", updateViewport);
    }, [maxWidth]);

    return isViewport;
}
